import React, {FC} from 'react';
import eyeIconOff from '~/shared/legacy_res/img/svg/eye-icon-off.svg';
import eyeIcon from '~/shared/legacy_res/img/svg/eye-icon.svg';
import styles from './EyeIcon.module.scss';

interface EyeIconInterface {
    onClickHandler?: () => void;
    showEyeIconOff?: boolean;
}

const EyeIcon: FC<EyeIconInterface> = ({onClickHandler, showEyeIconOff}) => {
    return (
        <div onClick={onClickHandler} className={styles.inputEye}>
            <img src={showEyeIconOff ? eyeIconOff : eyeIcon} />
        </div>
    );
};

export default EyeIcon;
